export const DocCols = (isExtraDocumentFeatureEnabled = false, isHblConsumptionEnabled = false) => {
    return [{
        headerClassName: 'data-table header fixedNumber',
        className: 'fixedNumber',
        show: true,
        accessor: 'fcrOriginalDocNumber',
        isActionLink: true,
        id: 'fcrNumber-col-link',
        fieldHeader: isExtraDocumentFeatureEnabled ? 'Document number' : (isHblConsumptionEnabled ? 'FCR/HBL number' : 'FCR number'),
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'status',
        id: 'status-col',
        fieldHeader: 'Status',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'finOpsStatus',
        id: 'finOpsStatus-col',
        fieldHeader: 'FinOps Status',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'sapsoNumber',
        id: 'sapsoNumber-col',
        fieldHeader: 'SAP SO Number',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'origin',
        id: 'origin-col',
        fieldHeader: 'Origin Service',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'destination',
        id: 'destination-col',
        fieldHeader: 'Destination Service',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'consginee',
        id: 'consignee-col',
        fieldHeader: 'Consignee',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'shipper',
        id: 'shipper-col',
        fieldHeader: 'Shipper',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'etd',
        id: 'etd-col',
        fieldHeader: 'ETD',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'eta',
        id: 'eta-col',
        fieldHeader: 'ETA',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'lastChangedBy',
        id: 'lastChangedBy-col',
        fieldHeader: 'Last Changed By',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'lastChangeDate',
        id: 'lastChangeDate-col',
        fieldHeader: 'Last Change Date',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'id',
        id: 'fcrID-col',
        fieldHeader: isExtraDocumentFeatureEnabled ? 'Document ID' : (isHblConsumptionEnabled ? 'FCR/HBL ID' : 'FCR ID'),
        sortable: true
    }];
}